/**
 * External dependencies
 */
import inherits from 'inherits';

export default class Estimate {
    

    constructor(cscom) {
        if (!(this instanceof Estimate)) {
            return new Estimate(cscom);
        }
        this.cscom = cscom;
    }

    updateSubscription(subscriptionId, planId) {
        return this.cscom.req.post('/customer-site-api/estimates/update-subscription/' + subscriptionId, null, {
            plan: planId,
        });
    }

    renewal(subscriptionId) {
        return this.cscom.req.post('/customer-site-api/estimates/renewal/' + subscriptionId, null, {});
    }

}
